/* Native, touch-friendly product rail. No autoplay, clones or third-party dependencies. */
(() => {
  if (customElements.get('si-product-rail')) return;
  customElements.define('si-product-rail', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.si-product-rail');
      this.controls = this.querySelector('.si-rail-controls');
      if (!this.list || !this.controls) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.prev = this.querySelector('[data-si-rail-prev]');
      this.next = this.querySelector('[data-si-rail-next]');
      this.update = () => {
        const max = this.list.scrollWidth - this.list.clientWidth;
        this.controls.hidden = max < 4;
        this.prev.disabled = this.list.scrollLeft < 4;
        this.next.disabled = this.list.scrollLeft >= max - 4;
      };
      const move = (direction) => this.list.scrollBy({
        left: direction * (this.list.firstElementChild?.getBoundingClientRect().width + 20 || this.list.clientWidth),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
      this.prev.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.list.addEventListener('scroll', this.update, { ...options, passive: true });
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.list);
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resize?.disconnect();
    }
  });
})();

(() => {
  if (customElements.get('si-campaign')) return;
  customElements.define('si-campaign', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const checkDate = () => {
        const end = Date.parse(this.dataset.end);
        if (!this.hasAttribute('data-editor') && (!Number.isFinite(end) || Date.now() > end)) this.hidden = true;
      };
      checkDate();
      this.timer = window.setInterval(checkDate, 30000);
      this.querySelector('[data-code]')?.addEventListener('click', async (event) => {
        const button = event.currentTarget;
        const status = this.querySelector('[role="status"]');
        try {
          await navigator.clipboard.writeText(button.dataset.code);
          status.textContent = 'Kod skopiowany. Użyj go przy zakupie.';
          button.querySelector('[data-copy-label]').textContent = 'Skopiowano ✓';
        } catch (_) {
          status.textContent = 'Skopiuj kod ręcznie: ' + button.dataset.code;
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); clearInterval(this.timer); }
  });
})();
